class PerformanceTracker {
    constructor(simulator) {
        this.simulator = simulator;
        this.metricCalculations = [];
        this.forceUpdateMetrics = [];
        this.metrics = [{}];
    }

    registerMetric(calculationCallBack) {
        this.metricCalculations.push(calculationCallBack);
    }

    registerForceUpdateMetric(forceUpdateCallBack) {
        this.forceUpdateMetrics.push(forceUpdateCallBack);
    }


    setInitialMetric(metricName, metricVal) {
        this.metrics[0][metricName] = metricVal;
    }

    getLatestMetrics() {
        return this.metrics[this.metrics.length - 1]
    }

    getMetricAmount() {
        return this.metrics.length;
    }

    storeMetrics() {
        var currMetric = {};
        currMetric.currHour = this.simulator.hoursPassed;

        this.metricCalculations.forEach(currUpdateFunc => {
            currUpdateFunc(this.simulator, currMetric);
        })

        this.metrics.push(currMetric);
    }

    //Needed for the portfolio management
    applyForceUpdateMetrics(){
        this.forceUpdateMetrics.forEach(currUpdateFunc => {
            currUpdateFunc(this.simulator, this.metrics[this.metrics.length - 1]);
        })
    }


}

module.exports = { PerformanceTracker };